'use client';

import Link from 'next/link';
import {
  Briefcase,
  Shield,
  HardDrive,
  Cloud,
  Key,
  Phone,
  Monitor,
  ClipboardCheck,
  LucideIcon,
} from 'lucide-react';
import type { StoreCategory } from '@/lib/data/software';

const iconMap: Record<string, LucideIcon> = {
  Briefcase,
  Shield,
  HardDrive,
  Cloud,
  Key,
  Phone,
  Monitor,
  ClipboardCheck,
};

interface CategoryCardProps {
  category: StoreCategory;
  productCount?: number;
}

export default function CategoryCard({ category, productCount }: CategoryCardProps) {
  const IconComponent = category.icon ? iconMap[category.icon] : Briefcase;

  return (
    <Link
      href={`/software/category/${category.slug}`}
      className="group block bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6 hover:border-blue-300 hover:shadow-lg transition-all duration-200"
    >
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
          <IconComponent className="w-6 h-6 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-gray-900 dark:text-gray-100 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
            {category.name}
          </h3>
          {category.description && (
            <p className="mt-1 text-sm text-gray-600 dark:text-gray-400 line-clamp-2">
              {category.description}
            </p>
          )}
          {productCount !== undefined && (
            <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
              {productCount} {productCount === 1 ? 'product' : 'products'}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
}
